import React, { CSSProperties, useEffect, useState } from "react";
import { Box, Typography } from "fds";
import { FileShareLinkPolicy } from "../../../types/files";
import { t } from "i18next";
import dayjs from "dayjs";
import i18n from "../../../locales/i18n";
interface FilesharePolicyTooltipProps {
  linkPolicy: FileShareLinkPolicy;
  logDate: number;
}

const FilesharePolicyTooltip: React.FC<FilesharePolicyTooltipProps> = ({
  linkPolicy,
  logDate,
}) => {
  if (!linkPolicy) return <Box></Box>;
  return (
    <Box direction={"column"} classes="fileSharePolicy">
      {linkPolicy.authType === "LOGIN" ? (
        <Typography exactColor="white" type="body4_rg">
          {t("file.link.tooltip.auth")}
        </Typography>
      ) : (
        <Typography exactColor="white" type="body4_rg">
          {(!!linkPolicy.password ||
            (!!linkPolicy.allowDays && linkPolicy.allowDays > -1)) &&
            "· "}
          {`${t("file.link.tooltip.noAuth")}(${
            linkPolicy.urlAction === "WEBUSING_AND_DOWNLOAD"
              ? `${t("file.action.preview")} & ${t("file.action.download")}`
              : linkPolicy.urlAction === "WEBUSING"
              ? t("file.link.previewOnly")
              : t("file.link.downloadOnly")
          })`}
        </Typography>
      )}
      {linkPolicy.authType !== "LOGIN" && linkPolicy.password && (
        <Box alignItems="center">
          <Typography exactColor="white" type="body4_rg">
            · {t("file.link.tooltip.setPw")}
            {":"}
          </Typography>
          <Typography exactColor="red" type="body4_rg" classes="mg ml-4">
            {linkPolicy.password}
          </Typography>
        </Box>
      )}
      {linkPolicy.authType !== "LOGIN" &&
        !!linkPolicy.allowDays &&
        linkPolicy.allowDays > -1 && (
          <Typography exactColor="white" type="body4_rg">
            {`· ${t("file.link.tooltip.setDueDate")}: ${dayjs(logDate)
              .add(linkPolicy.allowDays - 1, "d")
              .format(
                i18n.language.includes("ar") ? "DD/MM/YYYY" : "YYYY-MM-DD"
              )} GMT+${linkPolicy.allowDaysTimeZone ?? 0}`}
          </Typography>
        )}
    </Box>
  );
};
export default FilesharePolicyTooltip;
